import { render, staticRenderFns } from "./create-step-3.vue?vue&type=template&id=97a1bd5a&"
import script from "./create-step-3.vue?vue&type=script&lang=js&"
export * from "./create-step-3.vue?vue&type=script&lang=js&"
import style0 from "./create-step-3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports